// import React from 'react';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../assets/css/style.css';
import '../assets/css/style.css.map';
import '../assets/css/slick.min.css';
import patwedges from "../assets/img/update_2/normal/patwedges.png";
import pattyburger11 from "../assests/img/ProductsImages/PotatoBurgerPatty1.jpg";
import hashbrown1 from "../assets/img/update_2/normal/hashbrown1.jpg";
import hashbrown12 from "../assests/img/ProductsImages//HashBrown.jpg";
import herbchillyburgerpatty from "../assests/img/ProductsImages/HerbandChilliBurgerPatty.jpg";
import alootikki from "../assets/img/update_2/normal/alootikki01.png";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import potatoban1 from "../assets/img/potatoban1.png";
import header_valueadded from "../assets/img/header_valueadded.png";
import Footer from './footer';

import OurSpeciaity_comp from '../components/OurSpeciaity_comp';

const Ourspecialty = () => {
    // const location = useLocation();

    // useEffect(() => {
    //     window.scrollTo(0, 0);
    // }, [location]);
    const settingsscroll = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        appendDots: dots => (
            <ul style={{ display: 'flex', justifyContent: 'center', margin: '20px 0' }}>
                {dots.map((dot, index) => (
                    <li key={index} style={{ listStyle: 'none', margin: '0 10px' }}>
                        <div
                            style={{
                                width: '10px',
                                height: '10px',
                                borderRadius: '50%',
                                background: index === dot.props.current ? '#ff0000' : '#fff', // Red for active dot, white for others
                                border: '0px solid #333', // Customize the border color
                                cursor: 'pointer',
                                marginTop: '20px',
                            }}
                        />
                    </li>
                ))}
            </ul>
        )
    };
    return (
        <div>
            {/* <div className="breadcumb-wrapper" style={{ backgroundImage: `url(${breadcumb_bg_2})` }}>
                <div class="container z-index-common">
                    <div class="breadcumb-content">
                        <h1 class="breadcumb-title">Products</h1>
                        <ul class="breadcumb-menu">
                            <li><Link to="/Idgnew/home">Home</Link></li>
                            <li>Products</li>
                        </ul>
                    </div>
                </div>
            </div> */}
            <div classNameName="d-none d-md-block">
                <div id="slider" classNameName="ls-wp-container fitvidsignore hero-6 th-hero-carousel"
                    style={{ margin: '0 auto' }}>
                    <div classNameName="ls-slide" data-ls="duration:5000; kenburnsscale:1.2;">
                        <div className="infrastructure-name">
                            <div style={{ marginTop: "-40px" }}>
                                <ul style={{ listStyleType: 'none', padding: 20 }}>
                                    <li><h1 style={{ color: 'white', margin: 0, padding: 0 ,fontFamily:'helvetica',color:'white'}}>VALUE ADDED PRODUCTS</h1></li>
                                    <li>
                                        <Link to="/home" style={{ color: 'white', padding: 4 }}><span className="homeclass" style={{ fontFamily:'helvetica' }}>Home</span> &nbsp;</Link>
                                        <span style={{ color: 'white' }}>&gt; &nbsp;<span className="redname" style={{ fontFamily:'helvetica',color:'#F0B323',color: '#0f1138'}}>Value Added Products</span></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <img
                            width="2000"
                            height=""
                            src={header_valueadded}
                            className="ls-l ls-img-layer factory"
                            alt="image"
                            decoding="async"
                            style={{
                                fontSize: '36px',
                                height: "",
                                color: '#000',
                                stroke: '#000',
                                strokeWidth: '0px',
                                textAlign: 'right',
                                fontStyle: 'normal',
                                textDecoration: 'none',
                                textTransform: 'none',
                                fontWeight: '400',
                                letterSpacing: '0px',
                                backgroundPosition: '0% 0%',
                                backgroundRepeat: 'no-repeat',
                                backgroundClip: 'border-box',
                                overflow: 'visible',
                                left: '0px',
                                top: '107px',
                                WebkitBackgroundClip: 'border-box'
                            }}
                            data-ls="offsetxin:500; durationin:600; delayin:100; easingin:easeOutBack; rotatein:80; bgcolorin:transparent; colorin:transparent;"
                        />
                    </div>
                </div>
            </div>
            <OurSpeciaity_comp />

            <h2 className="section-heading" style={{ fontFamily:'helvetica',display:'none' }}>
                YUMWAY Hash Browns
            </h2>

            <div className="about-sec overflow-hidden pb-5" style={{ backgroundColor: '#f8f9fa',display:'none' }}>
                <div className="container">
                    <div className="row">
                       
                        <div className="col-xl-6" style={{ marginTop: '66px' }}>
                            <div className="title-area mb-30 text-center text-xl-start">
                                <h4 className="sec-title" style={{ fontFamily:'helvetica' }}>The Breakfast Hug</h4>
                            </div>
                            {/* <ul className="mt-n2 mb-25 text-center text-xl-start" style={{ fontFamily:'helvetica' }}>
                                <li>Great taste and texture with a soft potato inner side and crisp external bite</li>
                                <li>A perfect accompaniment for all-day breakfasts and Hi- Tea</li>
                                <li>Multiple garnishing options</li>
                            </ul> */}
                            <p>Crispy outside, soft inside. Made from real grated potatoes with zero preservatives.</p>
                            <div className="title-area mb-30 text-center text-xl-start">
                                <h4 className="sec-title" style={{ fontFamily:'helvetica' }}>Cooking</h4>
                            </div>
                            <ul className="mt-n2 mb-25 text-center text-xl-start" style={{ fontFamily:'helvetica' }}>
                                <li>
                                    Deep Fry: 175°C | 3.5 mins
                                </li>
                                <li>
                                    Air Fry: 180°C | 12 mins
                                </li>
                                <li>
                                    Bake: 200°C | 15 mins
                                </li>
                            </ul>
                            <p><b>Why Moms Love It:</b> Quick, safe, and pairs well with everything from eggs to ketchup.</p>

                            {/* <div className="title-area mb-30 text-center text-xl-start">
                                <h4 className="sec-title" style={{ fontFamily:'helvetica' }}>Storage</h4>
                            </div>
                            <ul className="mt-n2 mb-25 text-center text-xl-start" style={{ fontFamily:'helvetica' }}>
                                <li>Keep frozen at -18°C or below</li>
                                <li>Do not refreeze after thawing</li>
                                <li>Shelf life 24 Months</li>
                            </ul>
                            <div className="title-area mb-30 text-center text-xl-start">
                                <h4 className="sec-title" style={{ fontFamily:'helvetica' }}>Ingredients</h4>
                            </div>
                            <ul className="mt-n2 mb-25 text-center text-xl-start" style={{ fontFamily:'helvetica' }}>
                                <li>Potato Shreds, Corn Flour, Refined Palmolein Oil, Onion Powder & Salt.</li>
                            </ul> */}
                        </div>
                        <div className="col-xl-6 mt-4 mt-xl-0 d-flex justify-content-center align-items-center">
                            <div
                                className="testi-card-img"
                                style={{
                                    backgroundImage: `url(${hashbrown12})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    width: '600px',
                                    height: '500px',
                                   
                                    borderRadius: '10px',
                                    marginLeft: '-20px'
                                }}
                            ></div>
                        </div>
                    </div>
                </div>
            </div>            

            <h2 className="section-heading" style={{ fontFamily:'helvetica',display:'none' }}>
                YUMWAY CLASSIC PATTY WITH HERBS & CHILLI
            </h2>
            <div className="about-sec overflow-hidden pb-5" style={{ backgroundColor: '#f8f9fa',display:'none' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-xl-6 mt-4 mt-xl-0 d-flex justify-content-center align-items-center">
                            <div
                                className="testi-card-img"
                                style={{
                                    backgroundImage: `url(${herbchillyburgerpatty})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    width: '600px',
                                    height: '500px',
                                
                                    borderRadius: '10px',
                                    marginLeft: '-20px'
                                }}
                            ></div>
                        </div>
                        <div className="col-xl-6" style={{ marginTop: '66px' }}>
                            <div className="title-area mb-30 text-center text-xl-start">
                                <h4 className="sec-title" style={{ fontFamily:'helvetica' }}>Comfort food with a touch of spice.</h4>
                            </div>
                            {/* <ul className="mt-n2 mb-25 text-center text-xl-start" style={{ fontFamily:'helvetica' }}>
                                <li>Consistent quality burgers, anytime, every time</li>
                                <li>Consistent shape and piece weight which ensures zero wastage and enhances cost control</li>
                                <li>Create signature burgers with your choice of sauces and toppings</li>
                            </ul> */}
                            <p>Crispy Potato Patties filled with fresh aromatic herbs and chilli that give a richer taste.</p>
                            <div className="title-area mb-30 text-center text-xl-start">
                                <h4 className="sec-title" style={{ fontFamily:'helvetica' }}>Cooking</h4>
                            </div>
                            <ul className="mt-n2 mb-25 text-center text-xl-start" style={{ fontFamily:'helvetica' }}>
                                <li>
                                    Deep Fry: 175°C | 3.5 mins
                                </li>
                                <li>
                                    Air Fry: 180°C | 12 mins
                                </li>
                                <li>
                                    Bake: 200°C | 15 mins
                                </li>
                            </ul>
                            <p><b>Why Moms Love It:</b> Comforting herbs, a gentle chilli kick, and homestyle goodness in every bite.</p>

                            {/* <div className="title-area mb-30 text-center text-xl-start">
                                <h4 className="sec-title" style={{ fontFamily:'helvetica' }}>Storage</h4>
                            </div>
                            <ul className="mt-n2 mb-25 text-center text-xl-start" style={{ fontFamily:'helvetica' }}>
                                <li>Keep frozen at -18°C or below</li>
                                <li>Do not refreeze after thawing</li>
                                <li>Shelf life 24 Months</li>
                            </ul>
                            <div className="title-area mb-30 text-center text-xl-start">
                                <h4 className="sec-title" style={{ fontFamily:'helvetica' }}>Ingredients</h4>
                            </div>
                            <ul className="mt-n2 mb-25 text-center text-xl-start" style={{ fontFamily:'helvetica' }}>
                                <li>Potatoes, Refined Vegetable Oil, Corn Flour, Green Chilli Paste, Rice Flakes, Garlic Paste, Ginger Paste, Iodised Salt, Dehydrated White Onion Powder, Red Chilli Flakes</li>
                            </ul> */}
                        </div>
                    </div>
                </div>
            </div>
          
            <br />
            <h2 className="section-heading" style={{ fontFamily:'helvetica',display:'none' }}>
                YUMWAY Veg Burger Patty
            </h2>
            <div className="about-sec overflow-hidden pb-5" style={{ backgroundColor: '#f8f9fa',display:'none' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-xl-6" style={{ marginTop: '66px' }}>
                            <div className="title-area mb-30 text-center text-xl-start">
                                <h4 className="sec-title" style={{ fontFamily:'helvetica' }}>Stacked With Love</h4>
                            </div>
                            {/* <ul className="mt-n2 mb-25 text-center text-xl-start" style={{ fontFamily:'helvetica' }}>
                                <li>Consistent quality burgers, anytime, every time</li>
                                <li>Consistent shape and piece weight which ensures zero wastage and enhances cost control</li>
                                <li>Create signature burgers with your choice of sauces and toppings</li>
                            </ul> */}
                            <p>Lightly spiced, moist, and made with real potatoes. Ideal for home burgers, sliders, and tiffin sandwiches.</p>
                            {/* <div className="title-area mb-30 text-center text-xl-start">
                                <h4 className="sec-title" style={{ fontFamily:'helvetica' }}>Preparation</h4>
                            </div> */}
                            <ul className="mt-n2 mb-25 text-center text-xl-start" style={{ fontFamily:'helvetica' }}>
                                <li>
                                    Air-fryer friendly
                                </li>
                                <li>
                                    No artificial fillers
                                </li>
                            </ul>

                            {/* <div className="title-area mb-30 text-center text-xl-start">
                                <h4 className="sec-title" style={{ fontFamily:'helvetica' }}>Storage</h4>
                            </div>
                            <ul className="mt-n2 mb-25 text-center text-xl-start" style={{ fontFamily:'helvetica' }}>
                                <li>Keep frozen at -18°C or below</li>
                                <li>Do not refreeze after thawing</li>
                                <li>Shelf life 24 Months</li>
                            </ul>
                            <div className="title-area mb-30 text-center text-xl-start">
                                <h4 className="sec-title" style={{ fontFamily:'helvetica' }}>Ingredients</h4>
                            </div>
                            <ul className="mt-n2 mb-25 text-center text-xl-start" style={{ fontFamily:'helvetica' }}>
                                <li>Potatoes, Refined Vegetable Oil, Corn Flour, Green Chilli Paste, Rice Flakes, Garlic Paste, Ginger Paste, Iodised Salt, Dehydrated White Onion Powder, Red Chilli Flakes</li>
                            </ul> */}
                        </div>
                        <div className="col-xl-6 mt-4 mt-xl-0 d-flex justify-content-center align-items-center">
                            <div
                                className="testi-card-img"
                                style={{
                                    backgroundImage: `url(${pattyburger11})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    width: '600px',
                                    height: '500px',
                                   
                                    borderRadius: '10px',
                                    marginLeft: '-20px'
                                }}
                            ></div>
                        </div>
                    </div>
                </div>
            </div>
            <h2 className="section-heading" style={{ fontFamily:'helvetica',display:'none' }}>
                YUMWAY Aloo Tikki
            </h2>
            <div className="about-sec overflow-hidden pb-5" style={{ backgroundColor: '#f8f9fa',display:'none' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-xl-6 mt-4 mt-xl-2 d-flex justify-content-center align-items-center">
                            <div
                                className="testi-card-img"
                                style={{
                                    backgroundImage: `url(${patwedges})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    width: '600px',
                                    height: '500px',
                                    
                                    borderRadius: '10px',
                                    marginLeft: '-20px'

                                }}
                            ></div>
                        </div>
                        <div className="col-xl-6" style={{ marginTop: '66px' }}>
                            <div className="title-area mb-30 text-center text-xl-start">
                                <h4 className="sec-title" style={{ fontFamily:'helvetica' }}>The Street-Style Favourite — Cleaned Up.</h4>


                            </div>
                            {/* <ul className="mt-n2 mb-25 text-center text-xl-start" style={{ fontFamily:'helvetica' }}>
                                <li>Exceptional taste and great plate coverage</li>
                                <li>Skin-on wedge enhances flavour and retains more fiber</li>
                                <li>Versatile to use as a side order or main meal upgrade</li>
                            </ul> */}
                            <p>For chaats, wraps, or solo snack cravings. Loved by both moms and nostalgic millennials.</p>
                            <div className="title-area mb-30 text-center text-xl-start">
                                <h4 className="sec-title" style={{ fontFamily:'helvetica' }}>Cooking</h4>
                            </div>
                            <ul className="mt-n2 mb-25 text-center text-xl-start" style={{ fontFamily:'helvetica' }}>
                                <li>
                                    Deep Fry: 180°C | 2.5-3 mins
                                </li>
                                <li>
                                    Air Fry: 180°C | 10 mins
                                </li>
                                <li>
                                    Bake: 200°C | 12-15 mins
                                </li>
                            </ul>
                            <p><b>Lifestyle Fit:</b> Great for evening snacking, party starters, and quick Indian-style meals.</p>
                            {/* <div className="title-area mb-30 text-center text-xl-start">
                                <h4 className="sec-title" style={{ fontFamily:'helvetica' }}>Storage</h4>
                            </div>
                            <ul className="mt-n2 mb-25 text-center text-xl-start" style={{ fontFamily:'helvetica' }}>
                                <li>Keep frozen at -18°C or below</li>
                                <li>Do not refreeze after thawing</li>
                                <li>Shelf life 24 Months</li>
                            </ul>
                            <div className="title-area mb-30 text-center text-xl-start">
                                <h4 className="sec-title" style={{ fontFamily:'helvetica' }}>Ingredients</h4>
                            </div>
                            <ul className="mt-n2 mb-25 text-center text-xl-start" style={{ fontFamily:'helvetica' }}>
                                <li>Potatoes, Refined Palmolein Oil, Iodized salt, Corn Flour, Iodized Salt, Red Chilli Flakes, Dehydrated White Onion Powder</li>
                            </ul> */}
                        </div>
                    </div>
                </div>
            </div>
            <h2 className="section-heading" style={{ fontFamily:'helvetica',display:'none' }}>
                YUMWAY Potato Wedges
            </h2>
            <div className="about-sec overflow-hidden pb-5" style={{ backgroundColor: '#f8f9fa',display:'none' }}>
                <div className="container">
                    <div className="row">

                        <div className="col-xl-6" style={{ marginTop: '66px' }}>
                            <div className="title-area mb-30 text-center text-xl-start">
                                <h4 className="sec-title" style={{ fontFamily:'helvetica' }}>Rustic. Bold. Crowd-Pleasing.</h4>


                            </div>
                            {/* <ul className="mt-n2 mb-25 text-center text-xl-start" style={{ fontFamily:'helvetica' }}>
                                <li>Exceptional taste and great plate coverage</li>
                                <li>Skin-on wedge enhances flavour and retains more fiber</li>
                                <li>Versatile to use as a side order or main meal upgrade</li>
                            </ul> */}
                            <p>For sharing platters, grilled mains, and hearty snacks. Flavourful and thick-cut with no skin.</p>
                            <div className="title-area mb-30 text-center text-xl-start">
                                <h4 className="sec-title" style={{ fontFamily:'helvetica' }}>Cooking</h4>
                            </div>
                            <ul className="mt-n2 mb-25 text-center text-xl-start" style={{ fontFamily:'helvetica' }}>
                                <li>
                                    Deep Fry: 180°C | 3.5 mins
                                </li>
                                <li>
                                    Air Fry: 180°C | 12-14 mins
                                </li>
                                <li>
                                    Bake: 200°C | 14-16 mins
                                </li>
                            </ul>

                            {/* <div className="title-area mb-30 text-center text-xl-start">
                                <h4 className="sec-title" style={{ fontFamily:'helvetica' }}>Storage</h4>
                            </div>
                            <ul className="mt-n2 mb-25 text-center text-xl-start" style={{ fontFamily:'helvetica' }}>
                                <li>Keep frozen at -18°C or below</li>
                                <li>Do not refreeze after thawing</li>
                                <li>Shelf life 24 Months</li>
                            </ul>
                            <div className="title-area mb-30 text-center text-xl-start">
                                <h4 className="sec-title" style={{ fontFamily:'helvetica' }}>Ingredients</h4>
                            </div>
                            <ul className="mt-n2 mb-25 text-center text-xl-start" style={{ fontFamily:'helvetica' }}>
                                <li>Potatoes, Refined Palmolein Oil, Iodized salt, Corn Flour, Iodized Salt, Red Chilli Flakes, Dehydrated White Onion Powder</li>
                            </ul> */}
                        </div>
                        <div className="col-xl-6 mt-4 mt-xl-2 d-flex justify-content-center align-items-center">
                            <div
                                className="testi-card-img"
                                style={{
                                    backgroundImage: `url(${patwedges})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    width: '600px',
                                    height: '500px',
                                    
                                    borderRadius: '10px',
                                    marginLeft: '-20px'

                                }}
                            ></div>
                        </div>                        
                    </div>
                </div>
            </div>

            {/* <div class="mt-5">
                <div class="container">
                    <div class="title-area text-center">
                        <span class="sub-title">Best Sea food for family</span>
                        <h2 class="sec-title">Choose Our best Product</h2>
                    </div>
                    <div class="row th-carousel" data-slide-show="6" data-ml-slide-show="5" data-lg-slide-show="4"
                        data-md-slide-show="3" data-sm-slide-show="2" data-xs-slide-show="2">


                        <Slider {...settingsscroll}>


                            <div class="col-xl-2 col-lg-3 col-md-3 col-sm2">
                                <div class="category-border">
                                    <div class="category-border_img">
                                        <Link to="/Idgnew/product" className="">
                                            <img src={potato1} alt="Image" />
                                        </Link>
                                    </div>


                                </div>
                            </div>
                            <div class="col-xl-2 col-lg-3 col-md-3 col-sm2">
                                <div class="category-border">
                                    <div class="category-border_img">

                                        <Link to="/Idgnew/product" className="">
                                            <img src={potato2} alt="Image" />
                                        </Link>
                                    </div>

                                </div>
                            </div>
                            <div class="col-xl-2 col-lg-3 col-md-3 col-sm2">
                                <div class="category-border">
                                    <div class="category-border_img">
                                        <Link to="/Idgnew/product" className="">
                                            <img src={potato3} alt="Image" />
                                        </Link>
                                    </div>


                                </div>
                            </div>
                            <div class="col-xl-2 col-lg-3 col-md-3 col-sm2">
                                <div class="category-border">
                                    <div class="category-border_img">
                                        <Link to="/Idgnew/product" className="">
                                            <img src={potato4} alt="Image" />
                                        </Link>
                                    </div>

                                </div>
                            </div>
                            <div class="col-xl-2 col-lg-3 col-md-3 col-sm2">
                                <div class="category-border">
                                    <div class="category-border_img">
                                        <Link to="/Idgnew/product" className="">
                                            <img src={potato5} alt="Image" />
                                        </Link>
                                    </div>

                                </div>
                            </div>
                            <div class="col-xl-2 col-lg-3 col-md-3 col-sm2">
                                <div class="category-border">
                                    <div class="category-border_img">
                                        <Link to="/Idgnew/product" className="">
                                            <img src={potato6} alt="Image" />
                                        </Link>
                                    </div>

                                </div>
                            </div>
                            <div class="col-xl-2 col-lg-3 col-md-3 col-sm2">
                                <div class="category-border">
                                    <div class="category-border_img">
                                        <Link to="/Idgnew/product" className="">
                                            <img src={potato7} alt="Image" />
                                        </Link>
                                    </div>

                                </div>
                            </div>

                            <div class="col-xl-2 col-lg-3 col-md-3 col-sm2">
                                <div class="category-border">
                                    <div class="category-border_img">
                                        <Link to="/Idgnew/product" className="">
                                            <img src={potato8} alt="Image" />
                                        </Link>
                                    </div>

                                </div>
                            </div>

                            <div class="col-xl-2 col-lg-3 col-md-3 col-sm2">
                                <div class="category-border">
                                    <div class="category-border_img">
                                        <Link to="/Idgnew/product" className="">
                                            <img src={potato9} alt="Image" />
                                        </Link>
                                    </div>

                                </div>
                            </div>
                            <div class="col-xl-2 col-lg-3 col-md-3 col-sm2">
                                <div class="category-border">
                                    <div class="category-border_img">
                                        <Link to="/Idgnew/product" className="">
                                            <img src={potato10} alt="Image" />
                                        </Link>
                                    </div>

                                </div>
                            </div>

                        </Slider>
                    </div>
                </div>
            </div> */}
            <br />
            <Footer />
        </div>
    );
};

export default Ourspecialty;
